var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 19.375C43.8389 19.375 45.9375 17.2764 45.9375 14.6875C45.9375 12.0986 43.8389 10 41.25 10C38.6611 10 36.5625 12.0986 36.5625 14.6875C36.5625 17.2764 38.6611 19.375 41.25 19.375ZM25.79 41.0029L24.3447 44.374H17.8125C16.0869 44.374 14.6875 45.7734 14.6875 47.499C14.6875 49.2246 16.0869 50.624 17.8125 50.624H25.376C27.2559 50.624 28.9482 49.5068 29.6836 47.7832L30.542 45.7793L29.5 45.1641C27.8086 44.165 26.5645 42.6865 25.79 41.0029ZM52.1875 31.874H47.8877L45.3428 26.6738C44.1221 24.1787 41.8809 22.3545 39.3096 21.6992L32.3682 19.6348C29.6045 18.9707 26.7266 19.5811 24.4736 21.3086L20.5996 24.2783C19.2295 25.3281 18.9697 27.2891 20.0215 28.6592C21.0732 30.0293 23.0332 30.2861 24.4023 29.2373L28.2783 26.2676C29.0273 25.6924 29.9814 25.4863 30.7461 25.668L32.1816 26.0947L28.5234 34.6289C27.291 37.5078 28.3955 40.8799 31.0918 42.4717L39.3906 47.3711L36.708 55.9385C36.1924 57.585 37.1094 59.3379 38.7559 59.8535C39.0674 59.9512 39.3818 59.998 39.6914 59.998C41.0205 59.998 42.2529 59.1416 42.6719 57.8057L45.7617 47.9365C46.3389 45.9082 45.4795 43.7295 43.6484 42.625L37.668 39.0957L40.7256 31.4512L42.7051 35.4971C43.4863 37.0928 45.1387 38.123 46.915 38.123H52.1875C53.9131 38.123 55.3125 36.7236 55.3125 34.998C55.3125 33.2725 53.9131 31.874 52.1875 31.874Z",
    fill: "#E7EF7D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 34.5,
    stroke: "#E7EF7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/Running.3dc058639bce512ea581f4244a6b61fb.svg";
export { ForwardRef as ReactComponent };